import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';

const selectSession = (state: RootState) => state.auth.session;
const selectCurrent = (state: RootState) => state.auth.current;

export const isManagerSelector = createSelector(
  selectCurrent,
  (current) => current.role === 'manager',
);
export const isMemberSelector = createSelector(
  selectCurrent,
  (current) => current.role === 'member',
);
export const userSessionSelector = createSelector(
  selectCurrent,
  selectSession,
  (current, session) => ({
    gloplaId: current.organization.gloplaId,
    token: session?.token || '',
  }),
);
export const hasSessionSelector = createSelector(
  selectSession,
  (section) => !!section,
);

export const organizationSelector = createSelector(
  selectCurrent,
  (current) => current.organization,
);

export const organizationIdSelector = createSelector(
  selectCurrent,
  (current) => current.organization.id,
);
export const meSelector = createSelector(
  selectCurrent,
  (current) => current.me,
);
export const gloplaIdSelector = createSelector(
  selectCurrent,
  (current) => current.organization.gloplaId,
);

export const isLoggedInSelector = createSelector(
  selectCurrent,
  (current) => current.isLoggedIn,
);
